var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9302D",
  fillRule: "evenodd",
  d: "M2.667 28 16 4l13.334 24zm3.399-2L16 8.118 25.935 26zM17 22v2h-2v-2zm0-7.333v6h-2v-6z",
  clipRule: "evenodd"
})));
export default SvgWarning;